// import { UseFormReturn } from "react-hook-form"
// import { FormAgendaCorporativo, IVentaCorporativoNoc } from "./SaveAgendamientoNoc"
import { Grid } from "@mui/material"
import { gridSizeConst3, gridSizeConst9, gridSizeMdLg12, useTableColumnsInventario } from "@/shared"
import { SampleTable, TabTextLabel } from "@/shared/components/ui"
// import ModalProductoSelectComponente from "@/erp/inventario/ingreso-producto/shared/componente/ModalProductoSelectComponente"
import { CategoriaFCorporativaEnum, MaterialTransferido } from "@/shared/interfaces"
import { MaterialesKey, useMaterialesUtilizadosStore } from "@/store/erp"
import ModalProductoSelectComponente from "@/erp/inventario/ingreso-producto/shared/componente/ModalProductoSelectComponente"
import { useEffect, useState } from "react"
import { IFactibilidadCorporativo } from "@/shared/interfaces/erp/factibilidad_corporativo"

interface TabMaterialesEquiposNocProps {
  // noForm: IVentaCorporativoNoc | null
  // form: UseFormReturn<FormAgendaCorporativo, any, undefined>
  dataFactibilidadCorporativa?:IFactibilidadCorporativo
}

export default function TabMaterialesEquiposNoc({
  dataFactibilidadCorporativa
}: TabMaterialesEquiposNocProps) {

  const [MATERIALESEQUIPOS_FACTIBILIDAD, setMATERIALESEQUIPOS_FACTIBILIDAD] = useState<any>([]);
  const [EQUIPOSADICIONALES_FACTIBILIDAD, setEQUIPOSADICIONALES_FACTIBILIDAD] = useState<any>([]);

  const { columnsMaterialEquiposNoc, columnsMaterialAgendamientoNoc } = useTableColumnsInventario({
    key: MaterialesKey.ingresoProductos,
  });

  const ingresoProductos = useMaterialesUtilizadosStore(s => s.ingresoProductos);
  const addSelectedItemProducto = useMaterialesUtilizadosStore(s => s.addSelectedItemProducto);

  useEffect(() => {
    const auxMATERIALESEQUIPOS_FACTIBILIDAD = dataFactibilidadCorporativa?.productos_costeados?.filter(x=>x.categoria_fcorporativa==CategoriaFCorporativaEnum.MATERIALESEQUIPOS)
    const auxEQUIPOSADICIONALES_FACTIBILIDAD = dataFactibilidadCorporativa?.productos_costeados?.filter(x=>x.categoria_fcorporativa==CategoriaFCorporativaEnum.EQUIPOSADICIONALES)
    setMATERIALESEQUIPOS_FACTIBILIDAD(auxMATERIALESEQUIPOS_FACTIBILIDAD)
    setEQUIPOSADICIONALES_FACTIBILIDAD(auxEQUIPOSADICIONALES_FACTIBILIDAD)
  }, []);

  return (
    <Grid item container spacing={3}>

      {/*
      // =======================================================================
      // Se quitan los materiales y equipos que añadía agendamiento hasta nuevo aviso.
      // Si pasa una semana, borrar estos bloques (19/3/25)
      // =======================================================================
      */}
      <Grid container item  {...gridSizeMdLg12} >
        <Grid {...gridSizeConst9} alignContent={"center"}>
          <TabTextLabel text="Materiales y Equipos Instalación (NOC)" mt={0} pb={0} pl={0} />
        </Grid>
        <Grid container alignContent={"center"} justifyContent={"end"} {...gridSizeConst3}>
          <ModalProductoSelectComponente
            onChange={(e) => {
              const aux: MaterialTransferido = {
                id: e.id_producto,
                cantidad: 1,
                codigo: e.codigo,
                nombre: e.descripcion,
                series: [],
                contiene_serie: e.contiene_serie,
                stock_actual: e.stock_actual.toString(),
                categoria_fcorporativa: CategoriaFCorporativaEnum.MATERIALESEQUIPOS,
              };
              addSelectedItemProducto(aux, MaterialesKey.ingresoProductos);
            }}
            />
        </Grid>
      </Grid>

      <Grid container item {...gridSizeMdLg12}  >
        <SampleTable<MaterialTransferido>
          rowNumber={true}
          columns={columnsMaterialAgendamientoNoc}
          data={ingresoProductos}
        />
      </Grid>

      {/* /* producto_data: {
        categoria_producto: e.categoria_producto,
        codigo: e.codigo,
        descripcion: e.descripcion,
        stock_actual: e.stock_actual,
        subcategoria_producto: e?.subcategoria_producto_data?.nombre || "N/A",
        precios: e.precios,
      }, */}

      {/* {
        noForm?.equipos_adicionales?.length! > 0 &&
        (
          <>
            <Grid item  {...gridSizeMdLg12} >
              <TabTextLabel text="Equipos adicionales" mt={0} pb={0} pl={0} />
            </Grid>

            <Grid item {...gridSizeMdLg12}>
              <SampleTable<MaterialTransferido>
                rowNumber={true}
                columns={columnsEquiposAdicionalesNoc}
                data={noForm?.equipos_adicionales || []}
              />
            </Grid>
          </>
        )
      } */}


      <Grid item  {...gridSizeMdLg12} >
        <TabTextLabel text="Materiales y Equipos Factibilidad" mt={0} pb={0} pl={0} />
      </Grid>
      <Grid item xs={12}>
        <SampleTable<MaterialTransferido>
          rowNumber={true}
          columns={columnsMaterialEquiposNoc}
          data={MATERIALESEQUIPOS_FACTIBILIDAD || []}
        />
      </Grid>

      <Grid item  {...gridSizeMdLg12} >
        <TabTextLabel text="Equipos Adicionales" mt={0} pb={0} pl={0} />
      </Grid>
      <Grid item xs={12}>
        <SampleTable<MaterialTransferido>
          rowNumber={true}
          columns={columnsMaterialEquiposNoc}
          data={EQUIPOSADICIONALES_FACTIBILIDAD || []}
        />
      </Grid>



    </Grid>
  )

}